import { render, staticRenderFns } from "./Overlay.vue?vue&type=template&id=ddc730a0&scoped=true"
import script from "./Overlay.vue?vue&type=script&lang=ts"
export * from "./Overlay.vue?vue&type=script&lang=ts"
import style0 from "./Overlay.vue?vue&type=style&index=0&id=ddc730a0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddc730a0",
  null
  
)

export default component.exports